<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditTipoPesquisaModal
      v-if="showCreateEditTipoPesquisaModal"
      :tipoPesquisaId="tipoPesquisaIdSelected"
      @closeModal="closeCreateEditTipoPesquisaModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Tipos de Pesquisa de Satisfação</h5>
        <div v-if="getModuleUserByCode('4.02.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo TipoPesquisa"
            @click="createEditTipoPesquisa()"
          >
            <i class="ri-add-fill align-middle"></i>Novo tipo de pesquisa
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListTiposPesquisas
          :tiposPesquisas="tiposPesquisas"
          @editTipoPesquisa="createEditTipoPesquisa"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListTiposPesquisas from '@/components/pesquisaDeSatisfacao/tiposPesquisas/ListTiposPesquisas.vue'
import CreateEditTipoPesquisaModal from '@/components/pesquisaDeSatisfacao/tiposPesquisas/CreateEditTiposPesquisasModal.vue'

export default {
  name: 'TiposDePesquisas',

  components: {
    Layout,
    PageHeader,
    CreateEditTipoPesquisaModal,
    LoadingData,
    ListTiposPesquisas,
  },

  data() {
    return {
      title: 'Tipos de Pesquisas de Satisfação',
      items: [
        {
          text: 'Pesquisa de Satisfação',
        },
        {
          text: 'Tipo de Pesquisa de Satisfação',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditTipoPesquisaModal: false,
      tiposPesquisas: null,
      tipoPesquisaIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getTiposPesquisas() {
      try {
        this.tiposPesquisas = await this.$store.dispatch('getTiposPesquisas')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditTipoPesquisa(tipoPesquisaId) {
      this.tipoPesquisaIdSelected = tipoPesquisaId || null
      this.showCreateEditTipoPesquisaModal = true
    },

    closeCreateEditTipoPesquisaModal(loadListTiposPesquisas) {
      if (loadListTiposPesquisas) {
        this.getTiposPesquisas()
      }
      this.showCreateEditTipoPesquisaModal = false
    },
  },

  mounted() {
    this.getTiposPesquisas()
  },
}
</script>
